import tattoo1 from "../../images/tattooGallery/tattoo1.webp";
import tattoo2 from "../../images/tattooGallery/tattoo2.webp";
import tattoo3 from "../../images/tattooGallery/tattoo3.webp";
import tattoo4 from "../../images/tattooGallery/tattoo4.webp";
import tattoo5 from "../../images/tattooGallery/tattoo5.webp";
import tattoo6 from "../../images/tattooGallery/tattoo6.webp";
import tattoo7 from "../../images/tattooGallery/tattoo7.webp";
import tattoo8 from "../../images/tattooGallery/tattoo8.webp";
import tattoo9 from "../../images/tattooGallery/tattoo9.webp";
import tattoo10 from "../../images/tattooGallery/tattoo10.webp";
import tattoo11 from "../../images/tattooGallery/tattoo11.webp";
import tattoo12 from "../../images/tattooGallery/tattoo12.webp";
import tattoo13 from "../../images/tattooGallery/tattoo13.webp";
import tattoo14 from "../../images/tattooGallery/tattoo14.webp";
import tattoo15 from "../../images/tattooGallery/tattoo15.webp";
import tattoo16 from "../../images/tattooGallery/tattoo16.webp";
import tattoo17 from "../../images/tattooGallery/tattoo17.webp";
import tattoo18 from "../../images/tattooGallery/tattoo18.webp";
import tattoo19 from "../../images/tattooGallery/tattoo19.webp";
import tattoo20 from "../../images/tattooGallery/tattoo20.webp";
import tattoo21 from "../../images/tattooGallery/tattoo21.webp";
import tattoo22 from "../../images/tattooGallery/tattoo22.webp";
import tattoo23 from "../../images/tattooGallery/tattoo23.webp";
import tattoo24 from "../../images/tattooGallery/tattoo24.webp";
import tattoo25 from "../../images/tattooGallery/tattoo25.webp";
import tattoo26 from "../../images/tattooGallery/tattoo26.webp";
import tattoo27 from "../../images/tattooGallery/tattoo27.webp";
import tattoo28 from "../../images/tattooGallery/tattoo28.webp";
import tattoo29 from "../../images/tattooGallery/tattoo29.webp";
import tattoo30 from "../../images/tattooGallery/tattoo30.webp";
import tattoo31 from "../../images/tattooGallery/tattoo31.webp";
import tattoo32 from "../../images/tattooGallery/tattoo32.webp";
import tattoo33 from "../../images/tattooGallery/tattoo33.webp";
import tattoo34 from "../../images/tattooGallery/tattoo34.webp";
import tattoo35 from "../../images/tattooGallery/tattoo35.webp";

const tattooGalleryData = [
  { id: 1, src: tattoo1, alt: "Fine line flower tattoo", aspectRatio: "4 / 5" },
  { id: 2, src: tattoo2, alt: "Custom ornamental tattoo design", aspectRatio: "3 / 4" },
  { id: 3, src: tattoo3, alt: "Floral thigh tattoo", aspectRatio: "4 / 6" },
  { id: 4, src: tattoo4, alt: "Fine line flamingo tattoo", aspectRatio: "1 / 1.25" },
  { id: 5, src: tattoo5, alt: "Baby fine line text", aspectRatio: "4 / 5" },
  { id: 6, src: tattoo6, alt: "Fine line script tattoo", aspectRatio: "3 / 5" },
  { id: 7, src: tattoo7, alt: "Beetle tattoo", aspectRatio: "4 / 5" },
  { id: 8, src: tattoo8, alt: "Delicate floral tattoo", aspectRatio: "3 / 4" },
  { id: 9, src: tattoo9, alt: "Small vase tattoo", aspectRatio: "1 / 1.2" },
  { id: 10, src: tattoo10, alt: "Custom black work tattoo", aspectRatio: "4 / 6" },
  { id: 11, src: tattoo11, alt: "Fine line tattoo", aspectRatio: "4 / 5" },
  { id: 12, src: tattoo12, alt: "Metallic ballons tattoo", aspectRatio: "3 / 5" },
  { id: 13, src: tattoo13, alt: "Floral butterfly tattoo", aspectRatio: "4 / 6" },
  { id: 14, src: tattoo14, alt: "Custom illustrative tattoo", aspectRatio: "3 / 4" },
  { id: 15, src: tattoo15, alt: "Ornamental chest piece tattoo", aspectRatio: "1 / 1.3" },
  { id: 16, src: tattoo16, alt: "Fine line column tattoo", aspectRatio: "4 / 5" },
  { id: 17, src: tattoo17, alt: "Roadrunner tattoo", aspectRatio: "3 / 4" },
  { id: 18, src: tattoo18, alt: "Matching roadrunner tattoo", aspectRatio: "4 / 6" },
  { id: 19, src: tattoo19, alt: "Rose tattoo", aspectRatio: "4 / 5" },
  { id: 20, src: tattoo20, alt: "Colorful roadrunner tattoo", aspectRatio: "3 / 5" },
  { id: 21, src: tattoo21, alt: "Fine line illustrative tattoo", aspectRatio: "4 / 6" },
  { id: 22, src: tattoo22, alt: "Soft shading tattoo", aspectRatio: "3 / 4" },
  { id: 23, src: tattoo23, alt: "Minimal fine line tattoo", aspectRatio: "1 / 1.2" },
  { id: 24, src: tattoo24, alt: "Floral fine line tattoo", aspectRatio: "4 / 5" },
  { id: 25, src: tattoo25, alt: "Custom ornamental piece", aspectRatio: "3 / 5" },
  { id: 26, src: tattoo26, alt: "Detailed fine line tattoo", aspectRatio: "4 / 6" },
  { id: 27, src: tattoo27, alt: "Fine line tattoo artwork", aspectRatio: "4 / 5" },
  { id: 28, src: tattoo28, alt: "Delicate custom tattoo", aspectRatio: "3 / 4" },
  { id: 29, src: tattoo29, alt: "Fine line illustrative piece", aspectRatio: "4 / 6" },
  { id: 30, src: tattoo30, alt: "Minimal linework tattoo", aspectRatio: "4 / 5" },
  { id: 31, src: tattoo31, alt: "Custom fine line artwork", aspectRatio: "3 / 5" },
  { id: 32, src: tattoo32, alt: "Detailed linework tattoo", aspectRatio: "4 / 6" },
  { id: 33, src: tattoo33, alt: "Delicate tattoo design", aspectRatio: "3 / 4" },
  { id: 34, src: tattoo34, alt: "Fine line custom piece", aspectRatio: "4 / 5" },
  { id: 35, src: tattoo35, alt: "Custom tattoo artwork", aspectRatio: "3 / 5" },
];

export default tattooGalleryData;